<template>
  <d2-count-up :end="count" :decimals="decimals"/>
</template>

<script>
export default {
  name: 've-count',
  props: {
    data: {
      type: Object
    },
    settings: {
      type: Object
    }
  },
  computed: {
    count () {
      const row = this.data.rows[0]
      if (row === undefined) {
        return 0
      }
      if (this.data.columns.length < 1) {
        return 0
      }
      if (this.data.columns.length === 1) {
        const [key] = this.data.columns
        return row[key]
      }
      const [, key] = this.data.columns
      return row[key]
    },
    decimals () {
      const decimals = this.settings.decimals
      if (decimals) {
        return decimals
      }
      return 0
    }
  }
}
</script>
